<template>
    <div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :offset="offset"
          finished-text="没有更多了"
          @load="loadMore"
        >
          <div
            class="jifen-item van-hairline--bottom"
            v-for="(item, i) in dataList"
            :key="i"
            @click="goPage(item.sourceTransactionOrderlId)"
          >
            <div class="thead van-hairline--bottom">
              <div class="thead-left">
                <img v-lazy="item.headPic"  alt="" class="avatar" />
                <div class="name">{{ item.nickName }}</div>
              </div>
              <!-- <div class="thead-right">
                会员级员：<span class="grade">直推代理</span>
              </div> -->
            </div>
            <div class="tbody van-hairline--bottom">
              <div class="th">
                <img v-lazy="item.coverPhoto" alt="" class="thumb" />
              </div>
              <div class="bd">
                <div class="one-line">
                  <div class="goods-name">{{ item.productName }}</div>
                  <div class="price">￥{{ item.payCoin }}</div>
                </div>
                <div class="two-line">
                  <div class="date">下单时间:{{ item.addDatetime }}</div>
                  <!-- <div class="num">X1</div> -->
                </div>
                <div class="status three-line">
                  <span class="jifen"
                    >处理状态：{{
                      getTransactionStatusText(item.transactionStatus)
                    }}</span
                  >
                </div>
                <div class="three-line">
                  <div class="jifen">
                    {{ item.payTypeName }}:<span class="hlight"
                      >{{ item.payCoin }}积分</span
                    >
                  </div>
  
                  <!-- <div class="show-btn">查看详情</div> -->
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </template>
  
  <script>
  import common from "../tools/common";
  
  export default {
    data() {
      return {
        options: {
          type: "MemberIntegralList",
          current: 1,
          readType: this.readType
        },
        offset: 100,
        refreshing: false,
        loading: true,
        finished: false,
        dataList: []
      };
    },
    props: {
      readType: Number,
      beginTime: String,
      endTime: String
    },
    computed: {
      getTransactionStatusText() {
        return function(val) {
          return common.Text.getTransactionStatusText(val);
        };
      }
    },
    methods: {
      init() {
        this.getList();
      },
      onRefresh() {
        this.finished = false;
        this.loading = true;
        Object.assign(this.options, {
          current: 1
        });
        this.getList();
      },
      loadMore() {
        Object.assign(this.options, {
          current: this.options.current + 1
        });
        this.loading = true;
        this.getList();
      },
      getList() {
        var that = this;
        //console.log(this.options, "options");
        this.$store.dispatch(this.options).then(
          res => {
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }
            common.Response.callNotMsgResponse(res, function(result) {
             // console.log(result);
              if (result.data.length <= 0) {
                that.finished = true;
              }
              if (that.options.current > 1) {
                if (result.data.length > 0) {
                  result.data.forEach(element => {
                    that.dataList.push(element);
                  });
                }
              } else {
                that.dataList = result.data;
              }
            });
          },
          error => {
            console.log(error);
          }
        );
      },
      goPage(orderId) {
        this.$router.push("/orderDetails?id=" + orderId);
      }
    },
    watch: {
      beginTime: function(curVal, oldval) {
        if (curVal != oldval) {
          Object.assign(this.options, {
            current: 1,
            BeginTime: this.beginTime,
            EndTime: this.endTime
          });
          this.getList();
        }
      },
      endTime: function(curVal, oldval) {
        if (curVal != oldval) {
          Object.assign(this.options, {
            current: 1,
            BeginTime: this.beginTime,
            EndTime: this.endTime
          });
          this.getList();
        }
      }
    },
    created() {
      this.init();
    }
  };
  </script>
  
  <style lang="less" scoped>
  .jifenDetailPage {
    padding-bottom: 10px;
  }
  .selectdate-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 12px;
    display: flex;
    align-items: center;
    .lable-box {
      display: flex;
      align-items: center;
      .icon {
        width: 16px;
        height: 16px;
        object-fit: contain;
        margin-right: 10px;
      }
      .title {
        font-size: 16px;
        color: #333;
      }
    }
    .input-control {
      flex: 1;
      overflow: hidden;
      text-align: right;
      font-size: 14px;
      color: #333;
      margin-right: 8px;
    }
  }
  .tongji-section {
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .col {
      width: 32%;
      background: #fff;
      border-radius: 8px;
      padding: 15px 6px;
      height: 100px;
      .tongji-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        .price-box {
          font-size: 12px;
          color: #2b2b2b;
          .price {
            font-size: 22px;
            font-weight: bold;
          }
        }
        .des {
          font-size: 14px;
          color: #7c7c7c;
        }
      }
    }
  }
  .jifen-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 0;
  }
  //积分item
  .jifen-item {
    margin: 10px;
    background: #fff;
    padding: 0 14px;
    border-radius: 6px;
    overflow: hidden;
    box-sizing: border-box;
    .thead {
      display: flex;
      align-items: center;
      padding: 10px 0;
      .thead-left {
        flex: 1;
        overflow: hidden;
        display: flex;
        align-items: center;
        .avatar {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 8px;
        }
        .name {
          font-size: 13px;
          color: #3d3c3c;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .thead-right {
        margin-left: 15px;
        flex: 1;
        overflow: hidden;
        text-align: right;
        font-size: 12px;
        color: #ababab;
        .grade {
          color: #3d3c3c;
        }
      }
    }
    .tbody {
      display: flex;
      align-items: center;
      padding: 12px 0 15px;
      .th {
        margin-right: 15px;
        .thumb {
          width: 58px;
          height: 58px;
          object-fit: cover;
          border-radius: 4px;
        }
      }
      .bd {
        flex: 1;
        overflow: hidden;
        .one-line {
          display: flex;
          align-items: center;
          overflow: hidden;
          margin-bottom: 6px;
          .goods-name {
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            color: #000000;
          }
          .price {
            margin-left: 15px;
            font-size: 14px;
            color: #000000;
            font-family: Arial, Helvetica, sans-serif;
          }
        }
        .two-line {
          display: flex;
          align-items: center;
          overflow: hidden;
          .date {
            flex: 1;
            overflow: hidden;
            font-size: 12px;
            color: #b7b7b7;
          }
          .num {
            font-size: 10px;
            color: #b7b7b7;
            margin-left: 15px;
          }
        }
        .three-line {
          margin-top: 3px;
          display: flex;
          align-items: center;
          .jifen {
            flex: 1;
            overflow: hidden;
            font-size: 10px;
            color: #000;
            .hlight {
              color: #ff375b;
              font-size: 13px;
            }
          }
          .show-btn {
            margin-left: 15px;
            line-height: 1;
            font-size: 12px;
            padding: 4px 8px;
            border: 1px solid;
            color: #464646;
            border-radius: 999px;
          }
        }
      }
    }
  }
  </style>
  